declare var PRODUCTION: any;

export var BASE_URL = 'http://127.0.0.1:8081';
if(typeof PRODUCTION !== "undefined" && PRODUCTION) {
  BASE_URL = 'https://howmuch.net';
}
export const API_VERSION = 'api';



// WEBPACK FOOTER //
// ./src/app/shared/base.url.ts